/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
// Utils
// import { notifyPaymentRequired } from 'common/utils/customerValidation'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'
import { useLogout } from 'core/hooks/api'

// Styled Elements
import {
  MenuDetailedWrapper,
  Header,
  Text,
  XStack,
  YStack,
  Divider,
  MenuNavLink,
  Btn
} from '../common.elements'

// Map Redux Props
function ProfileSidebar() {
  // Hooks
  const [userCredentials] = useLocalStorage('userCredentials', {})
  const { logoutUser } = useLogout()

  // Functions
  const handleLogout = async () => {
    await logoutUser()
  }
  return (
    <MenuDetailedWrapper style={{ flexDirection: 'column-reverse', paddingBottom: '40px' }}>
      <YStack style={{ gap: '8px' }}>

        <YStack style={{ padding: '0 8px' }}>

          {userCredentials?.role_id === 1 && (
          <MenuNavLink to="/business-details">Business Details</MenuNavLink>
        )}
          <MenuNavLink to={`/user-details/${userCredentials.user_id}`}>Profile</MenuNavLink>
          <MenuNavLink to="/settings?page=0">Settings</MenuNavLink>

          <Btn onClick={handleLogout}>Logout</Btn>

          <XStack style={{ padding: '8px 15px 15px 15px' }}>
            <Divider />
          </XStack>

          <YStack style={{ gap: '8px', padding: '0 15px' }}>
            {/* <Text>{`${userCredentials?.email}`}</Text> */}
            <XStack style={{ alignItems: 'center', gap: '12px' }}>
              <YStack>
                <Header>{`${userCredentials?.name_first} ${userCredentials?.name_last}`}</Header>
                <Text>{`${userCredentials?.role_desc}`}</Text>
              </YStack>
            </XStack>
          </YStack>
        </YStack>
      </YStack>

    </MenuDetailedWrapper>
  )
}

export default ProfileSidebar
